import React, { useState } from 'react';
import PropTypes from 'prop-types';
import {
  Card, CardBody, Col, Row,
} from 'reactstrap';
import ReactTableBase from 'src/shared/components/table/ReactTableBase';
import { useTranslation } from 'react-i18next';
import { Tooltip } from '@mui/material';
import Fab from '@mui/material/Fab';
import AddIcon from '@mui/icons-material/Add';
import DeliveryRateModal from '../../AddOrUpdate/components/OutletSettingDetailsModal';

const DeliveryRateDetailsView = ({ reactTableData }) => {
  const [rows, setData] = useState(reactTableData.tableRowsData);
  const { t } = useTranslation('common');

  const tableConfig = {
    isEditable: false,
    isSortable: false,
    isResizable: false,
    withPagination: true,
    withSearchEngine: true,
    manualPageSize: [10, 50, 100, 1000],
    placeholder: 'Search by Rider Pass Code ...',
  };
  const [viewDetailPopup, setViewDetailPopup] = useState(false);
  const [isTitle, setTitle] = useState(null);
  const Add = () => {
    setViewDetailPopup(true);
    setTitle("Add - Hub Setting Details");
  }
  return (
    <Col md={12} lg={12}>
      <Card>
        <CardBody>
          <Row>
            <Col md={12}>
              <h3 className="page-title">Hub Setting Details</h3>
            </Col>
          </Row>
          <Tooltip title="Click here to add new details">
            <Fab size="small" color="secondary" aria-label="add" style={{ float: "right" }} onClick={() => Add()}>
              <AddIcon />
            </Fab>
          </Tooltip>
          <ReactTableBase
            name={t('instution_type.view.name_map')}
            key={'searchable'}
            columns={reactTableData.tableHeaderData}
            data={rows}
            tableConfig={tableConfig}
          />
          {viewDetailPopup &&
            <DeliveryRateModal
              modalShow={viewDetailPopup}
              setModalShow={setViewDetailPopup}
              //userData={temp}
              isTitle={isTitle}         />}
        </CardBody>
      </Card>
    </Col>
  );
};

DeliveryRateDetailsView.propTypes = {
  reactTableData: PropTypes.shape({
    tableHeaderData: PropTypes.arrayOf(PropTypes.shape({
      key: PropTypes.string,
      name: PropTypes.string,
    })),
    tableRowsData: PropTypes.arrayOf(PropTypes.shape()),
  }).isRequired,
};

export default DeliveryRateDetailsView;
